module.exports = __webpack_public_path__ + "static/media/kadikis.ea063c96.jpg";